export default __webpack_public_path__ + "static/upperBar-9ce414e59f3c172cebb757481a035c0b.svg";